import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { ApiService } from './api.service';
import { AuthService } from "./auth.service";


@Injectable()
export class CommonService {
  private cutoff: any;
  private cutoffFetchObservable: any;

  private config: any;
  private configFetchObservable: Observable<any>;

  public etsData: any;
  private etsDataFetchObservable: Observable<any>;

  public editConfig: any;
  private editConfigObservable: Observable<any>;

  public miscConfig: any;
  private miscConfigObservable: Observable<any>;

  public canceConfig: any;
  private cancelConfigObservable: Observable<any>;

  private airportList: any;
  private airportListObservable: Observable<any>;

  public disableActionsConfig: any;
  private disableActionsConfigObservable: Observable<any>;

  public workflowConfig;

  public tripDetailsConfig: any; 

  public value = '0';

  roleConfig = new BehaviorSubject<any>({});
  cuttoffObj = new BehaviorSubject<any>([]);
  cityCuttoffObj = new BehaviorSubject<any>([]);
  editcuttoffObj = new BehaviorSubject<any>(null);
  cancelcuttoffObj = new BehaviorSubject<any>(null);
  public cities = new BehaviorSubject<any>(null);
  public costcenter = new BehaviorSubject<Array<any>>([]);
  constructor(
    private apiService: ApiService,
    private authService: AuthService,

  ) { }

  public fetchWorkflowConfig() {
    if (this.workflowConfig){
      return new Observable(observer => {
        observer.next(this.workflowConfig);
        observer.complete();
      });
    }else{
      return new Observable((obs) => {
        const httpRequest = this.apiService.httpRequest({
          url: 'fetchWorkflowConfig',
          type: 'GET',
          queryParams: {
            buid: this.authService.user.buId,
            empGuid: this.authService.user.employeeGuid,
            client: this.authService.client.client
          }
        });
        httpRequest.subscribe((res: any) => {
          this.workflowConfig = res;
          obs.next(this.workflowConfig);
          obs.complete();
        });
      });
    }
  }

  public assignData() {
    const httpRequest = this.apiService.httpRequest({
      url: 'assignData',
      type: 'GET',
      queryParams: {
        buid: this.authService.user.buId,
        empGuid: this.authService.user.employeeGuid
      }
    });
    return httpRequest;
  }

  public fetchConfig(): any {
    if (this.config) {
      return new Observable(observer => {
        observer.next(this.config);
        observer.complete();
      });
    } else {
      if (!this.configFetchObservable) {
        this.configFetchObservable = new Observable(observer => {
          const httpRequest = this.apiService.httpRequest({
            url: 'fetchConfig',
            type: 'GET',
            queryParams: {
              buid: this.authService.user.buId,
              empGuid: this.authService.user.employeeGuid,
              client: this.authService.client.client
            }
          });
          httpRequest.subscribe((response) => {
            this.configFetchObservable = undefined;
            this.config = response;
            observer.next(this.config);
            observer.complete();
          }, (error) => {
            observer.error(error);
          });
        });
      }
      return this.configFetchObservable;
    }
  }

  getTripDetailsEleConfig(elementKeys: string[]){
    if(!this.tripDetailsConfig){
      this.tripDetailsConfig = this.getConfigForElementKey(this.config, 'Trip Details Form');
    }
    const res = elementKeys.map((elementKey: string)=>{
      return this.getConfigForElementKey(this.tripDetailsConfig, elementKey);
    });
    return res;
  }


  public getConfigForElementKey(config: any, elementKey: string): any {
    if (config.elementKey === elementKey) {
      return config;
    }
    if (config.pageConfigList) {
      for (const page of config.pageConfigList) {
        const hasMatch = this.getConfigForElementKey(page, elementKey);
        if (hasMatch) { return hasMatch; }
      }
    } else if (config.sectionConfigList) {
      for (const section of config.sectionConfigList) {
        const hasMatch = this.getConfigForElementKey(section, elementKey);
        if (hasMatch) { return hasMatch; }
      }
    } else if (config.elementConfigList) {
      for (const element of config.elementConfigList) {
        const hasMatch = this.getConfigForElementKey(element, elementKey);
        if (hasMatch) { return hasMatch; }
      }
    } else if (config instanceof Array) {
      for (const element of config) {
        const hasMatch = this.getConfigForElementKey(element, elementKey);
        if (hasMatch) { return hasMatch; }
      }
    }
    return false;
  }

  public getEtsData(): Observable<any> {
    if (this.etsData) {
      return new Observable(observer => {
        observer.next(this.etsData);
        observer.complete();
      });
    } else {
      if (!this.etsDataFetchObservable) {
        this.etsDataFetchObservable = new Observable(observer => {
          const httpRequest = this.apiService.httpRequest({
            url: 'fetchEtsData',
            type: 'GET'
          });
          httpRequest.subscribe((response) => {
            this.etsDataFetchObservable = undefined;
            this.etsData = response;
            observer.next(this.etsData);
            observer.complete();
          });
        });
      }
      return this.etsDataFetchObservable;
    }
  }

  public getSavedLocations() {
    const savedLocations = [];
    return new Observable(observer => {
      this.getEtsData().subscribe((etsData) => {
        if (this.getValue() === '1') {
          etsData.offices.forEach((office) => {
            office.isSaved = true;
            savedLocations.push(office);
          });
          observer.next(savedLocations);
          observer.complete();
        } else if (this.getValue() === '0') {
          this.authService.getUserInfo().subscribe((userData) => {
            const home = userData.employee.primaryAddress.home;
            home.isSaved = true;
            userData.employee.primaryAddress.home.type = `${userData.employee.employeeName}'s Home`;
            savedLocations.push(userData.employee.primaryAddress.home);
            etsData.offices.forEach((office) => {
              office.isSaved = true;
              savedLocations.push(office);
            });
            observer.next(savedLocations);
            observer.complete();
          });
        }
      });
    });
  }

  setValue(val) {
    this.value = val;
  }

  getValue() {
    return this.value;
  }
  public fetchCutoff(): Observable<any> {
    if (this.cutoff) {
      return new Observable(observer => {
        observer.next(this.cutoff);
        observer.complete();
      });
    } else {
      if (!this.cutoffFetchObservable) {
        this.cutoffFetchObservable = new Observable(observer => {
          const httpRequest = this.apiService.httpRequest({
            url: 'fetchCutoff',
            type: 'GET',
            queryParams: {
              buid: this.authService.user.buId,
              empGuid: this.authService.user.employeeGuid,
              client: this.authService.client.client
            }
          });
          httpRequest.subscribe((response) => {
            this.cutoffFetchObservable = undefined;
            this.cutoff = response;
            observer.next(this.cutoff);
            observer.complete();
          });
        });
      }
      return this.cutoffFetchObservable;
    }
  }

  public fetchCityCutoff(){

    return this.apiService.httpRequest({
      url: 'fetchCityCutoff',
      type: 'GET',
      queryParams: {
        buid: this.authService.user.buId,
        empGuid: this.authService.user.employeeGuid,
        client: this.authService.client.client
      }
    });
  }

  public fetchEditConfig(): Observable<any> {
    if (this.editConfig) {
      return new Observable(observer => {
        observer.next(this.editConfig);
        observer.complete();
      });
    } else {
      if (!this.editConfigObservable) {
        this.editConfigObservable = new Observable(observer => {
          const httpRequest = this.apiService.httpRequest({
            url: 'fetchEditConfig',
            type: 'GET',
            queryParams: {
              buid: this.authService.user.buId,
              empGuid: this.authService.user.employeeGuid,
              client: this.authService.client.client
            }
          });
          httpRequest.subscribe((response) => {
            this.editConfigObservable = undefined;
            this.editConfig = response;
            observer.next(this.editConfig);
            observer.complete();
          });
        });
      }
      return this.editConfigObservable;
    }
  }

  public fetchMiscConfig(): Observable<any> {
    if (this.miscConfig) {
      return new Observable(observer => {
        observer.next(this.miscConfig);
        observer.complete();
      });
    } else {
      if (!this.miscConfigObservable) {
        this.miscConfigObservable = new Observable(observer => {
          const httpRequest = this.apiService.httpRequest({
            url: 'fetchMiscConfig',
            type: 'GET',
            queryParams: {
              buid: this.authService.user.buId,
              empGuid: this.authService.user.employeeGuid,
              client: this.authService.client.client
            }
          });
          httpRequest.subscribe((response) => {
            this.miscConfigObservable = undefined;
            this.miscConfig = response;
            observer.next(this.miscConfig);
            observer.complete();
          });
        });
      }
      return this.miscConfigObservable;
    }
  }

  public addCostCenter(request)
  {
    return this.apiService.httpRequest({
      url: 'addCostCenter',
      type: 'POST',
      queryParams: request
    });
  }

  public fetchCancelConfig(): Observable<any> {
    if (this.canceConfig) {
      return new Observable(observer => {
        observer.next(this.canceConfig);
        observer.complete();
      });
    } else {
      if (!this.cancelConfigObservable) {
        this.cancelConfigObservable = new Observable(observer => {
          const httpRequest = this.apiService.httpRequest({
            url: 'cancelBookingCutoff',
            type: 'GET',
            queryParams: {
              buid: this.authService.user.buId,
              empGuid: this.authService.user.employeeGuid,
              client: this.authService.client.client
            }
          });
          httpRequest.subscribe((response) => {
            this.cancelConfigObservable = undefined;
            this.canceConfig = response;
            observer.next(this.canceConfig);
            observer.complete();
          });
        });
      }
      return this.cancelConfigObservable;
    }
  }

  public fetchDisableActionsConfig(): Observable<any> {
    if (this.disableActionsConfig) {
      return new Observable(observer => {
        observer.next(this.disableActionsConfig);
        observer.complete();
      });
    } else {
      if (!this.disableActionsConfigObservable) {
        this.disableActionsConfigObservable = new Observable(observer => {
          const httpRequest = this.apiService.httpRequest({
            url: 'fetchDisableActionsConfig',
            type: 'GET',
            queryParams: {
              buid: this.authService.user.buId,
              empGuid: this.authService.user.employeeGuid,
              client: this.authService.client.client
            }
          });
          httpRequest.subscribe((response) => {
            this.disableActionsConfigObservable = undefined;
            this.disableActionsConfig = response;
            observer.next(this.disableActionsConfig);
            observer.complete();
          });
        });
      }
      return this.disableActionsConfigObservable;
    }
  }

  public postBulkBookingUpdate(request: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'bookingBulkUpdate',
      type: 'POST',
      body: request
    });
  }

  public fetchCabTypeConfig() {
    const queryParams = {
      buid: this.authService.user.buId,
      client: this.authService.client.client
    };
    return this.apiService.httpRequest({
      url: 'designationBasedConfig',
      type: 'GET',
      queryParams
    });
  }

  public getRiderCab(riderGuIds, city,numberOfRiders){
    const queryParams = {
      buid: this.authService.user.buId,
      city,
      riderGuIds,
      numberOfRiders
    };
    return this.apiService.httpRequest({
      url: 'fetchRiderCab',
      type: 'GET',
      queryParams
    });
  }

  public saveRecipient(riderEmpGuid, representativeEmpGuid){
    const request = {
      riderEmpGuid,
      representativeEmpGuid
    };
    const queryParams = {
      buid: this.authService.user.buId
    };
    return this.apiService.httpRequest({
      url: 'submitRecipient',
      type: 'POST',
      body: request,
      queryParams
    });
  }

  public fetchRecipient(riderEmpGuid){
    const queryParams = {
      buid: this.authService.user.buId
    };
    return this.apiService.httpRequest({
      url: 'fetchRecipient',
      type: 'POST',
      body: [riderEmpGuid],
      queryParams
    });
  }

  public fetchAirports(): Observable<any> {
    if (this.airportList) {
      return new Observable(observer => {
        observer.next(this.airportList);
        observer.complete();
      });
    } else {
      if (!this.airportListObservable) {
        this.airportListObservable = new Observable(observer => {
          const httpRequest = this.apiService.httpRequest({
            url: 'fetchAirports',
            type: 'GET',
            queryParams: {
              buid: this.authService.user.buId,
              empGuid: this.authService.user.employeeGuid,
              client: this.authService.client.client
            }
          });
          httpRequest.subscribe((response) => {
            this.airportListObservable = undefined;
            const airports = [];
            response.forEach((cityAirports) => {
              for (const airport of cityAirports.airports) {
                airport.isSaved = true;
                airport.isAirport = true;
                airport.city = cityAirports.city;
                airports.push(airport);
              }
            });
            this.airportList = airports;
            observer.next(this.airportList);
            observer.complete();
          });
        });
      }
      return this.airportListObservable;
    }
  }

  public getCityOfficeMapping(city, riderGuIds){
    const queryParams = {
      buid: this.authService.user.buId,
      city,
      riders: riderGuIds
    };
    return this.apiService.httpRequest({
      url: 'cityOfficeMapping',
      type: 'GET',
      queryParams
    });
  }

  public getSmallLogo(showKey?: boolean){
    const queryParams =  showKey ? {
      buid: this.authService.user.buId,
      key: 'rentlz-logo-big.png'
    } : {
      buid: this.authService.user.buId,
    };
    return this.apiService.httpRequestBlob({
      url: 'fetchLogo',
      type: 'GET',
      queryParams
    });
  }

  public getPolicyData(city): Observable<any[]>{
    return this.apiService.httpRequest({
      url: 'policyPopupData',
      type: 'GET',
      queryParams: {
        client: this.authService.client.client,
        city
      }
    });
  }

  public getTransportData(city,bookingType):Observable<any>{
    return this.apiService.httpRequest({
      url:'cityTransportMap',
      type:'GET',
      queryParams:{
        city,
        bookingType
      }
    })
  }

  public fetchAVAConfig(){
    return this.apiService.httpRequestBlob({
      url:'vendorAllocationConfig',
      type:'GET',      
      queryParams: {
        buid: this.authService.user.buId,
      }
    })
  }

  clearService() {
    this.cutoff = undefined;
    this.config = undefined;
    this.etsData = undefined;
    this.editConfig = undefined;
    this.canceConfig = undefined;
    this.airportList = undefined;
    this.disableActionsConfig = undefined;
    this.miscConfig = undefined;
    this.workflowConfig = undefined;
  }

  public setLoadingFalse(){
    const loader = document.getElementById('loader');
    loader.style.display = 'none';
  }
}
